import importTransforms from 'cio/utils/analytics/transforms/import';
import account from 'cio/utils/analytics/transforms/account';
import campaign from 'cio/utils/analytics/transforms/campaign';
import broadcast from 'cio/utils/analytics/transforms/broadcast';
import people from 'cio/utils/analytics/transforms/people';
import objects from 'cio/utils/analytics/transforms/objects';
import shortcuts from 'cio/utils/analytics/transforms/shortcuts';
import segment from 'cio/utils/analytics/transforms/segment';
import adNetworks from 'cio/utils/analytics/transforms/ad-networks';
import workspace from 'cio/utils/analytics/transforms/workspace';
import push from 'cio/utils/analytics/transforms/push';
import inApp from 'cio/utils/analytics/transforms/in_app';
import message from 'cio/utils/analytics/transforms/message';
import email from 'cio/utils/analytics/transforms/email';
import integrations from 'cio/utils/analytics/transforms/integrations';
import logs from 'cio/utils/analytics/transforms/logs';
import user from 'cio/utils/analytics/transforms/user';
import onboarding from 'cio/utils/analytics/transforms/onboarding';
import signup from 'cio/utils/analytics/transforms/signup';
import dashboard from 'cio/utils/analytics/transforms/dashboard';
import snippets from 'cio/utils/analytics/transforms/snippets';
import collections from 'cio/utils/analytics/transforms/collections';
import analysis from 'cio/utils/analytics/transforms/analysis';
import tags from 'cio/utils/analytics/transforms/tags';
import comments from 'cio/utils/analytics/transforms/comments';
import transactional from 'cio/utils/analytics/transforms/transactional';
import events from 'cio/utils/analytics/transforms/events';
import forms from 'cio/utils/analytics/transforms/forms';
import facebookLeadAds from 'cio/utils/analytics/transforms/facebook-lead-ads';
import dataWarehouse from 'cio/utils/analytics/transforms/data-warehouse';
import sqlImports from 'cio/utils/analytics/transforms/sql-imports';
import library from 'cio/utils/analytics/transforms/library';
import datacenter from 'cio/utils/analytics/transforms/datacenter';
import languages from 'cio/utils/analytics/transforms/languages';
import experimentalFeatures from 'cio/utils/analytics/transforms/experimental-features';
import assetLibrary from 'cio/utils/analytics/transforms/asset-library';
import planBilling from 'cio/utils/analytics/transforms/plan-billing';
import subscriptionCenter from 'cio/utils/analytics/transforms/subscription-center';
import RouteInfo from '@ember/routing/-private/route-info';
import helpCenter from 'cio/utils/analytics/transforms/help-center';
import inlineSupport from 'cio/utils/analytics/transforms/inline-support';
import inlineContractsSales from 'cio/utils/analytics/transforms/inline-contracts-sales';
import objectsLiquid from 'cio/utils/analytics/transforms/objects-liquid';
import renderer from 'cio/utils/analytics/transforms/renderer';
import uiTest from 'cio/utils/analytics/transforms/ui-tester';
import productActivation from 'cio/utils/analytics/transforms/product-activation';
import performance from 'cio/utils/analytics/transforms/performance';
import testDeliveryMode from 'cio/utils/analytics/transforms/test-delivery-mode';

export type Model = {
  id: string;
  [key: string]: any;
};

export type Data = {
  model?: Model;
  route?: RouteInfo;
  experimentName?: string;
  experimentVariation?: string;
  [key: string]: any;
};

export type EventDataTransformer = (data: Data) => {
  [key: string]: string | string[] | number | boolean | undefined | Record<string, any>;
};

export type TransformsList = {
  [key: string]: EventDataTransformer;
};

export const EventTransforms: {
  [key: string]: {
    [key: string]: EventDataTransformer;
  };
} = {
  import: importTransforms,
  account,
  campaign,
  broadcast,
  people,
  objects,
  segment,
  adNetworks,
  workspace,
  push,
  message,
  integrations,
  inApp,
  logs,
  user,
  onboarding,
  signup,
  dashboard,
  email,
  snippets,
  collections,
  analysis,
  tags,
  comments,
  transactional,
  events,
  forms,
  facebookLeadAds,
  dataWarehouse,
  sqlImports,
  library,
  shortcuts,
  datacenter,
  languages,
  experimentalFeatures,
  assetLibrary,
  planBilling,
  subscriptionCenter,
  helpCenter,
  inlineSupport,
  inlineContractsSales,
  objectsLiquid,
  renderer,
  uiTest,
  productActivation,
  performance,
  testDeliveryMode,
};
